module.exports = __webpack_public_path__ + "img/insta.cfde406c.png";